// extracted by css-extract-rspack-plugin
export default {"cls1":"NavImpactStats-cls1_BaT","cls2":"NavImpactStats-cls2_cq8 NavImpactStats-cls1_BaT"};